module.exports = __webpack_public_path__ + "61dde457bc523d1597f2382ee1bad6fb.pdf";